/* export const apiDomain = "http://sana-bau-cms:8888/";
export const photosUrl = "http://sana-bau-cms:8888/assets/photos/uploads/"; */
export const photosUrl = "https://api.sana-bau.at/assets/photos/uploads/";
export const apiDomain = "https://api.sana-bau.at/";
export const userToken = localStorage.getItem('token');